import { URL_PARAMETER_DOCUMENT } from '../../constants/url.parameter.names';
import { getLastSegment } from '../../utility/urlHelpers.new';

// (String, (String -> String)) -> EnvironmentService
const makeEnvironmentService = (userName, getUrlParameter, window) => {
    const getCurrentDocumentUrl = () => getUrlParameter(URL_PARAMETER_DOCUMENT);

    const getCurrentFileName = () => {
        const currentUrl = getCurrentDocumentUrl();

        if (!currentUrl) {
            return null;
        }

        const lastSegment = getLastSegment(currentUrl);

        if (lastSegment) {
            return lastSegment;
        }

        return null;
    };

    const getUserName = () => userName;

    const getCurrentLocation = () => window.location;

    return {
        getCurrentDocumentUrl,
        getCurrentFileName,
        getUserName,
        getCurrentLocation,
    };
};

export default makeEnvironmentService;
